export const environment = {
  production: true,
  apiUrl: 'https://api.rem-global.com'
};
